import { lazy } from 'react';
const EngItemStock = lazy(() => import('./EngItemStock'));

const EngItemStockRoutes = [
  {
    path: '/stock/consumption',
    component: EngItemStock
  }
];

export default EngItemStockRoutes;
